import { Navigate, useLocation } from 'react-router-dom';
import { useSiteFeatureFlags } from '../../hooks/useSiteFeatureFlags';

// In the Transfer Site template only these public pages exist. Anything else (the
// CRM's industries, shop, events, portfolio, tools, quotes, ...) goes to the home page.
const ALLOWED_PREFIXES = ['/p/', '/terms-conditions', '/privacy-policy', '/accessibility',
  '/login', '/register', '/accept-invite', '/verify-email', '/account'];

// The old CRM addresses people may still have bookmarked land on the template's own pages.
const REDIRECTS = { '/about': '/p/about', '/faq': '/p/faq', '/contact': '/p/support' };

export const isTemplatePath = (path) =>
  path === '/' || ALLOWED_PREFIXES.some((p) => path === p.replace(/\/$/, '') || path.startsWith(p.endsWith('/') ? p : `${p}/`));

/**
 * Wrap a CRM-only public route (or the whole public route table). With the template
 * off it does nothing at all. While the flag is still loading, a page that would be
 * allowed renders straight away and one that would not waits - so a hidden CRM page
 * never flashes before the redirect.
 */
const SiteTemplateGuard = ({ children }) => {
  const { pathname } = useLocation();
  const { _loaded, transfer_site_enabled } = useSiteFeatureFlags();
  const allowed = isTemplatePath(pathname);
  if (!_loaded) return allowed ? children : null;
  if (!transfer_site_enabled || allowed) return children;
  return <Navigate to={REDIRECTS[pathname] || '/'} replace />;
};

export default SiteTemplateGuard;
